// extracted by mini-css-extract-plugin
export default {"item":"_8d71cf41"};